function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { actions as userActions } from 'researcher/user';
import { translate } from 'shared/helper/translate/util';
import * as c from './constants';
export var requestPaymentMethod = function requestPaymentMethod(paymentMethod) {
  return {
    type: c.PAYMENT_METHOD_REQUESTED,
    paymentMethod: paymentMethod
  };
};
export var paymentMethodReady = function paymentMethodReady(paymentMethod) {
  return {
    type: c.PAYMENT_METHOD_READY,
    paymentMethod: paymentMethod
  };
};
export var loadPayment = function loadPayment() {
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    return dispatch(application.get('/api/payment/load')).then(function (payment) {
      if (payment.user) {
        dispatch(userActions.updateUser(payment.user));
      }
      dispatch({
        type: c.PAYMENT_LOADED,
        payment: payment
      });
    });
  };
};
export var updatePaymentCurrencies = function updatePaymentCurrencies() {
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    return dispatch(application.get('/api/payment/currencies')).then(function (currencies) {
      return dispatch({
        type: c.PAYMENT_CURRENCIES_UPDATED,
        currencies: currencies
      });
    });
  };
};
export var persistPayment = function persistPayment(endpoint, identity, data) {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    dispatch(save());
    var paymentData = _objectSpread(_objectSpread({}, data), {}, {
      invoiceAddressSameAsBilling: !data.invoiceAddressDiffersFromBilling
    });
    return dispatch(application.put(endpoint, paymentData)).then(function (_ref4) {
      var error = _ref4.error,
        redirectUrl = _ref4.redirectUrl,
        redirectForm = _ref4.redirectForm;
      if (error) {
        dispatch(saveFailed(error));
      } else {
        // Redirect via POST form
        if (redirectForm) {
          var fragment = document.createElement('div');
          fragment.innerHTML = redirectForm.trim();
          var form = fragment.querySelector('form');
          document.body.appendChild(form);
          form.submit();
          return;
        }

        // Redirect via GET
        if (redirectUrl) {
          window.location.assign(redirectUrl);
          return;
        }
        dispatch(saveFailed());
      }
    }).catch(function (err) {
      return dispatch(saveFailed(err));
    });
  };
};
export var save = function save() {
  return {
    type: c.SAVE_REQUESTED
  };
};
var notifySaveFailure = function notifySaveFailure() {
  return {
    type: c.SAVE_FAILED
  };
};
export var saveFailed = function saveFailed(error) {
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    var message = {
      type: 'error',
      message: 'An error occurred processing your payment',
      modal: true,
      action: {
        text: 'Go Back'
      }
    };
    if (error && typeof error !== 'boolean') {
      message = _objectSpread(_objectSpread({}, message), {}, {
        message: 'There was a problem saving your payment: %(error)s',
        params: {
          error: translate(error.message || error, {}, getState().application.translations)
        }
      });
    }
    dispatch(application.addMessage(message));
    dispatch(notifySaveFailure());
  };
};
export var requestBraintreeClientToken = function requestBraintreeClientToken() {
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    return dispatch(application.get('/api/payment/braintree-client-token'));
  };
};
export var updateFormData = function updateFormData(formData) {
  return {
    type: c.PAYMENT_FORM_DATA_UPDATED,
    formData: formData
  };
};